import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-fourstrep',
  templateUrl: './fourstrep.component.html',
  styleUrls: ['./fourstrep.component.scss']
})
export class FourstrepComponent implements OnInit {

  exposition: CardContent = {
    title: '4Strep',
    subtitle: 'Modelling many serotypes of streptococcus pneumoniae at once',
    image_source: 'assets/images/4Strep.png',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Partners</h4>GlaxoSmithKline, Epimos',
      '<h4>Methods</h4>Stochastic Individual-based Modelling',
      '<h4>Technology / Skills</h4>Java, Swing, DES',
      '<h4>Term</h4>2018',
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
